define('local/models/InquiryHistoryRepository', [
    'ps/local-storage',
    'moment'
], function(
    LocalStorage,
    moment
) {
    var InquiryHistoryRepository = function() {
        var _self = this;
        var _storageName = 'inquiryOffers';
        var _storage;

        /**
         * @returns {string}
         */
        this.getStorageName = function() {
            return _storageName;
        };

        /**
         * @returns {LocalStorage}
         */
        this.getStorage = function() {
            if(typeof _storage == 'undefined') {
                _storage = new LocalStorage(_self.getStorageName());
            }
            return _storage;
        };

        this.load = function() {
            var storage = this.getStorage();
            var data = storage.load();
            if(!data) {
                data = {};
            }
            return data;
        };

        this.save = function(offerId) {
            var data = this.load();
            var expirationDate = moment().add('1', 'days');
            data[offerId] = expirationDate.format('YYYY-MM-DD HH:mm:ss');
            var storage = this.getStorage();
            storage.save(data);
        };

        /**
         * @returns {boolean}
         */
        this.isSend = function(offerId) {
            var data = this.load();
            if(data.hasOwnProperty(offerId) != -1 && moment().isBefore(data[offerId])) {
                return true;
            }
            return false;
        };

        this.clean = function() {
            var storage = this.getStorage();
            storage.clean();
        }
    };

    return InquiryHistoryRepository;
});